import React, { useState, useEffect } from 'react'
import Style from '../styles/pages/AllCheckIn.module.scss'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import arrowLeft from '../shared/images/icon-arrow-left.svg'
import { Box, Typography, List, ListItem , Avatar} from '@mui/material'
import arrow from '../shared/images/arrow-down.svg'
import { RootState } from '../store/GlobalStore'
import { Reservation } from '../utils/Interface'
import { useTranslation } from 'react-i18next';
const AllCheckInPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { t } = useTranslation();
     const [reservationData, setReservationData] = useState<Reservation[]>([]);
     const [activeTab, setActiveTab] = useState<'incoming' | 'past'>('incoming');
    useEffect(() => {
       if(authState?.reservations !== null){
            const data = authState?.reservations
            const currentResId = authState?.currentResId;
            console.log(data)
            console.log(currentResId)
            // Filtrer les réservations selon l'onglet actif
            const filteredReservations = data.filter((reservation) => {
                return reservation.asterioId === Number(currentResId);
            });

            console.log(filteredReservations)
        
            setReservationData(filteredReservations)
        }
    }, [authState?.reservations, activeTab]);
    

    return (
        <div className={Style.MainContainer}>
            <div className={Style.TopContainer}>
                <Link to='/mon-compte'>
                    <button className={Style.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>{t('checkIn')}</h2>
                <p>{t('checkInSub')}</p>
            </div>
            <div>
                <div className={Style.DesktopFormField}>
                    <Box className={Style.AccountBox}>
                    <List>
                    {reservationData.length > 0 ? (
                            reservationData.map((reservation, reservationIndex) => {
                                return (
                                    <div key={`reservation-${reservationIndex}`} className={Style.ResaContainer}>
                                           {reservation.Bookings
                                           .filter((booking) => !booking.cancelled)
                                           .map((booking, bookingIndex) => (
                                            <ListItem
                                                key={`booking-${bookingIndex}`}
                                                className={`${Style.AllRoom} ${
                                                    false ? Style.cancelled : ''
                                                } ${bookingIndex === (reservation.Bookings.length - 1) ? Style.lastItem : ''}`}
                                                component={!booking.cancelled ? Link : 'div'}
                                                to={`/check-in/${booking.ressourceTypeCode}/${reservation.asterioId}/${booking.bookingId}`}
                                            >
                                                <div className={Style.AnimationContent}>
                                                    <img
                                                        src={`${process.env.REACT_APP_BASE_URL}${booking.displayImage}` || 'default-image.png'}
                                                        alt={booking.ressourceTypeCode}
                                                        className={Style.AnimationImage}
                                                    />
                                                    <div className={Style.AnimationInfo}>
                                                        {/*<div className={Style.Lieu}>Les Settons</div>*/}
                                                        <Typography variant="body2" className={Style.strong}>
                                                            {booking.ressourceTypeLabel}
                                                        </Typography>
                                                        <Typography variant="body2" className={Style.thin}>
                                                        {booking.ressourceLabel}
                                                        </Typography>
                                                        <Typography variant="body2" className={Style.strong}>
                                                            {reservation.Folios.find(
                                                                (folio) => folio.productCode === booking.forfaitCode
                                                            )?.unitPrice || ''}{' '}
                                                            {reservation.Folios.find(
                                                                (folio) => folio.productCode === booking.forfaitCode
                                                            )
                                                                ? '€ ' + t('by_night')
                                                                : ''}
                                                        </Typography>
                                                        <Typography variant="body2" className={Style.redStrong}>
                                                            {booking.cancelled ? 'ANNULE' : ''}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <img src={arrow} alt="Détail" className={Style.ArrowIcon} />
                                            </ListItem>
                                        ))}
                                    </div>
                            )})
                        ) : (
                            <Typography>
                                {activeTab === 'incoming' ? t('noFuture') : t('noPast')}
                            </Typography>
                        )}
                        </List>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default AllCheckInPage